export default "__VITE_ASSET__CORMjcY___"